export const DIAGNOSTICS_TABS = [
  'overview',
  'camera-interfaces',
  'citysense-car-logs',
  'system-logs',
  'log-downloads',
  'cs-metrics',
  'control-unit-logs',
  'cu-system-logs',
  'cu-log-downloads',
  'cu-metrics',
] as const

export type DiagnosticsTab = (typeof DIAGNOSTICS_TABS)[number]

export const isDiagnosticsTab = (value: string): value is DiagnosticsTab =>
  (DIAGNOSTICS_TABS as readonly string[]).includes(value)

/**
 * Each vehicle runs a system analyzer on the car server (cs) and another one on the control unit (cu)
 */
export type DiagnosticsSystem = 'cs' | 'cu'
